var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_5794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C11.0533 0 10.2858 0.767511 10.2858 1.71432V5.14285H13.7143V1.71432C13.7143 0.767511 12.9468 0 12.0001 0Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0C35.0532 0 34.2856 0.767511 34.2856 1.71432V5.14285H37.7142V1.71432C37.7143 0.767511 36.9468 0 36 0Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 5.14282H37.7143V12C37.7143 12.9468 36.9468 13.7143 36 13.7143C35.0532 13.7143 34.2857 12.9468 34.2857 12V5.14282H13.7142V12C13.7142 12.9468 12.9467 13.7143 11.9999 13.7143C11.0531 13.7143 10.2856 12.9468 10.2856 12V5.14282H5.14285C2.30253 5.14282 0 7.44535 0 10.2857V42.8571C0 45.6974 2.30253 48 5.14285 48H42.8571C45.6975 48 48 45.6974 48 42.8571V10.2857C48 7.44535 45.6975 5.14282 42.8571 5.14282ZM44.5714 42.8571C44.5714 43.8039 43.8039 44.5714 42.857 44.5714H5.14285C4.19605 44.5714 3.42854 43.8039 3.42854 42.8571V20.5714H44.5714V42.8571Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 24H10.2857C9.33892 24 8.57141 24.7675 8.57141 25.7143C8.57141 26.6611 9.33892 27.4286 10.2857 27.4286H13.7143C14.6611 27.4286 15.4286 26.6611 15.4286 25.7143C15.4286 24.7675 14.6611 24 13.7143 24Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7143 24H22.2857C21.3389 24 20.5714 24.7675 20.5714 25.7143C20.5714 26.6611 21.3389 27.4286 22.2857 27.4286H25.7143C26.6611 27.4286 27.4286 26.6611 27.4286 25.7143C27.4286 24.7675 26.6611 24 25.7143 24Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7143 24H34.2857C33.3389 24 32.5714 24.7675 32.5714 25.7143C32.5714 26.6611 33.3389 27.4286 34.2857 27.4286H37.7143C38.6611 27.4286 39.4286 26.6611 39.4286 25.7143C39.4286 24.7675 38.661 24 37.7143 24Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 30.8572H10.2857C9.33892 30.8572 8.57141 31.6247 8.57141 32.5715C8.57141 33.5183 9.33892 34.2858 10.2857 34.2858H13.7143C14.6611 34.2858 15.4286 33.5183 15.4286 32.5715C15.4286 31.6247 14.6611 30.8572 13.7143 30.8572Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7143 30.8572H22.2857C21.3389 30.8572 20.5714 31.6247 20.5714 32.5715C20.5714 33.5183 21.3389 34.2858 22.2857 34.2858H25.7143C26.6611 34.2858 27.4286 33.5183 27.4286 32.5715C27.4286 31.6247 26.6611 30.8572 25.7143 30.8572Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7143 30.8572H34.2857C33.3389 30.8572 32.5714 31.6247 32.5714 32.5715C32.5714 33.5183 33.3389 34.2858 34.2857 34.2858H37.7143C38.6611 34.2858 39.4286 33.5183 39.4286 32.5715C39.4285 31.6247 38.661 30.8572 37.7143 30.8572Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 37.7141H10.2857C9.33892 37.7141 8.57141 38.4816 8.57141 39.4284C8.57141 40.3752 9.33892 41.1426 10.2857 41.1426H13.7143C14.6611 41.1426 15.4286 40.3751 15.4286 39.4283C15.4286 38.4815 14.6611 37.7141 13.7143 37.7141Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7143 37.7141H22.2857C21.3389 37.7141 20.5714 38.4816 20.5714 39.4284C20.5714 40.3752 21.3389 41.1427 22.2857 41.1427H25.7143C26.6611 41.1427 27.4286 40.3752 27.4286 39.4284C27.4286 38.4816 26.6611 37.7141 25.7143 37.7141Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7143 37.7141H34.2857C33.3389 37.7141 32.5714 38.4816 32.5714 39.4284C32.5714 40.3752 33.3389 41.1427 34.2857 41.1427H37.7143C38.6611 41.1427 39.4286 40.3752 39.4286 39.4284C39.4286 38.4816 38.661 37.7141 37.7143 37.7141Z",
    fill: "#F5F5FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_5794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.769a27441bafd6d71a505ca903481182.svg";
export { ForwardRef as ReactComponent };